export type LearningTrack = 'ai' | 'cloud' | 'security' | 'project' | 'general';

export interface AICourse {
  id: string;
  slug: string;
  titleKey: string;
  descriptionKey: string;
  level: 'beginner' | 'intermediate' | 'advanced';
  durationHours: number;
  topics: string[];
  track: LearningTrack;
  relatedExamKeywords?: string[];
  status: 'available' | 'coming_soon';
}

export interface StudyGuide {
  id: string;
  slug: string;
  titleKey: string;
  descriptionKey: string;
  readMinutes: number;
  track: LearningTrack;
}

export const AI_COURSES: AICourse[] = [
  {
    id: 'ai-fundamentals',
    slug: 'ai-fundamentals',
    titleKey: 'learn.courses.aiFundamentals.title',
    descriptionKey: 'learn.courses.aiFundamentals.description',
    level: 'beginner',
    durationHours: 6,
    topics: ['ML basics', 'Neural networks', 'Responsible AI'],
    track: 'ai',
    relatedExamKeywords: ['AWS', 'Azure', 'AI'],
    status: 'available',
  },
  {
    id: 'prompt-engineering',
    slug: 'prompt-engineering',
    titleKey: 'learn.courses.promptEngineering.title',
    descriptionKey: 'learn.courses.promptEngineering.description',
    level: 'beginner',
    durationHours: 4,
    topics: ['Prompt patterns', 'RAG basics', 'Evaluation'],
    track: 'ai',
    status: 'available',
  },
  {
    id: 'genai-for-professionals',
    slug: 'genai-for-professionals',
    titleKey: 'learn.courses.genAiProfessionals.title',
    descriptionKey: 'learn.courses.genAiProfessionals.description',
    level: 'intermediate',
    durationHours: 8,
    topics: ['Copilots', 'Workflow automation', 'Governance'],
    track: 'ai',
    status: 'available',
  },
  {
    id: 'ai-governance',
    slug: 'ai-governance',
    titleKey: 'learn.courses.aiGovernance.title',
    descriptionKey: 'learn.courses.aiGovernance.description',
    level: 'intermediate',
    durationHours: 6,
    topics: ['AI RMF', 'Risk tiers', 'Policies', 'Oversight'],
    track: 'ai',
    relatedExamKeywords: ['AI', 'Security', 'Governance'],
    status: 'available',
  },
  {
    id: 'ml-on-cloud',
    slug: 'ml-on-cloud',
    titleKey: 'learn.courses.mlOnCloud.title',
    descriptionKey: 'learn.courses.mlOnCloud.description',
    level: 'intermediate',
    durationHours: 10,
    topics: ['SageMaker', 'Vertex AI', 'MLOps'],
    track: 'cloud',
    relatedExamKeywords: ['AWS', 'GCP', 'Machine Learning'],
    status: 'coming_soon',
  },
  {
    id: 'ai-security',
    slug: 'ai-security',
    titleKey: 'learn.courses.aiSecurity.title',
    descriptionKey: 'learn.courses.aiSecurity.description',
    level: 'advanced',
    durationHours: 5,
    topics: ['Threat models', 'Data privacy', 'Model risks'],
    track: 'security',
    relatedExamKeywords: ['Security', 'CISSP'],
    status: 'coming_soon',
  },
];

export const STUDY_GUIDES: StudyGuide[] = [
  {
    id: 'cert-study-plan',
    slug: 'cert-study-plan',
    titleKey: 'learn.guides.studyPlan.title',
    descriptionKey: 'learn.guides.studyPlan.description',
    readMinutes: 8,
    track: 'general',
  },
  {
    id: 'practice-vs-exam-mode',
    slug: 'practice-vs-exam-mode',
    titleKey: 'learn.guides.practiceVsExam.title',
    descriptionKey: 'learn.guides.practiceVsExam.description',
    readMinutes: 5,
    track: 'general',
  },
  {
    id: 'aws-cert-path',
    slug: 'aws-cert-path',
    titleKey: 'learn.guides.awsPath.title',
    descriptionKey: 'learn.guides.awsPath.description',
    readMinutes: 12,
    track: 'cloud',
  },
  {
    id: 'ai-cert-landscape',
    slug: 'ai-cert-landscape',
    titleKey: 'learn.guides.aiCertLandscape.title',
    descriptionKey: 'learn.guides.aiCertLandscape.description',
    readMinutes: 10,
    track: 'ai',
  },
];
